export const ATTACHMENT_DOWNLOAD_SUCCESS = "ATTACHMENT_DOWNLOAD_SUCCESS";
export const ATTACHMENT_DOWNLOAD_FAILURE = "ATTACHMENT_DOWNLOAD_FAILURE";